import React, { useState } from 'react';
import CurrencyAmount from 'components/CurrencyAmount';
import { getCurrencyInfo } from 'utils/util';
import { DefaultStates } from '..';

const supportCurrency = ['USD'];

interface AmountProps {
    balance: DefaultStates['balance'];
    currency: string;
    isIRA?: boolean;
}

const Amount: React.FC<AmountProps> = ({ balance, currency, isIRA }) => {
    const [currencyList] = useState(() => {
        return supportCurrency.map(currency => {
            const item = getCurrencyInfo(currency);

            return {
                label: item.name,
                icon: item.icon,
                value: currency
            };
        });
    });

    return (
        <div className="space-box">
            <p className="label">{isIRA ? __('Distribution Amount') : __('Withdrawal Amount')}</p>
            <CurrencyAmount
                currencyList={currencyList}
                inputConfig={{
                    name: 'amount',
                    placeholder: '0.00',
                    checker: (value, { $formutil }) => {
                        if (!value || value <= 0) {
                            return __('Please enter an amount');
                        }

                        if (balance && value > balance) {
                            return isIRA
                                ? __('Please lower your distribution amount or try with a different bank account')
                                : __('Please lower your withdrawal amount or try with a different bank account');
                        }

                        if (!/^(([1-9]\d*)|(0\.\d{1,2})|([1-9]\d*\.\d{1,2}))$/.test(value)) {
                            return __('The amount you entered is invalid');
                        }

                        const taxRate = ($formutil!.$params as any).tax_rate;

                        if (taxRate !== undefined && Number(taxRate) * Number(value) < 1) {
                            return __('Please enter a valid amount.');
                        }

                        return true;
                    }
                }}
                selectConfig={{
                    disabled: currencyList.length <= 1,
                    name: 'currency',
                    $defaultValue: currency,
                    showIcon: false
                }}
            />
        </div>
    );
};

export default Amount;
